// extracted by mini-css-extract-plugin
module.exports = {"footer":"footerManifesto-module--footer--3Gpbo","block":"footerManifesto-module--block--20Bsq","special":"footerManifesto-module--special--2rNkj"};